import { Component, OnInit } from '@angular/core';
import { statusCode } from 'app/auth/models/commonEnum';
import { Subject } from 'rxjs';
import { first } from 'rxjs/operators';
import { DashboardService } from './dashboard.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
	// private _unsubscribeAll: Subject<any>;
	// public getDashboard: any;
	// public userCount: any;
	// public totalExpert: any;
	// public totalexpertAssignApplication: any;
	// public expertcommentreceive: any;
	dashboardCount: any[] = []
	dashboardCountForHydrogen : any[] = []
	dashboardCountForCoeProposal : any[] = []
	dashboardCountForEuttcProposal : any[] = []
	constructor(
		private _dashboardService: DashboardService,
	) { 
		// this._unsubscribeAll = new Subject();
	}

	ngOnInit(): void {
		this.getDashboardCount();
		this.getDashboardDetailsForHydrogen();
		this.getDashboardDetailsForCoeProposal();
		this.getDashboardDetailsForEuttcProposal();
	}


	getDashboardCount() {

		this._dashboardService.getDashboardDetails().subscribe((result: any) => {
			if (result.statusCode == statusCode.SUCCESS) {
				this.dashboardCount = result["data"]["response"];
				//console.log(this.dashboardCount);
			}
		})
	}

	getDashboardDetailsForHydrogen() {

		this._dashboardService.getDashboardDetailsForHydrogen().subscribe((result: any) => {
			if (result.statusCode == statusCode.SUCCESS) {
				this.dashboardCountForHydrogen = result["data"]["response"];
				//console.log(this.dashboardCountForHydrogen);
				
			}
		})
	}

	getDashboardDetailsForCoeProposal() {

		this._dashboardService.getDashboardDetailsForCoeProposal().subscribe((result: any) => {
			if (result.statusCode == statusCode.SUCCESS) {
				this.dashboardCountForCoeProposal = result["data"]["response"];
				//console.log(this.dashboardCountForCoeProposal);
				
			}
		})
	}

	getDashboardDetailsForEuttcProposal() {

		this._dashboardService.getDashboardDetailsForEuttcProposal().subscribe((result: any) => {
			if (result.statusCode == statusCode.SUCCESS) {
				this.dashboardCountForEuttcProposal = result["data"]["response"];
				//console.log(this.dashboardCountForCoeProposal);
				
			}
		})
	}

}
